'use client';

import { PageExpandableEntryFragment } from '@/__generated__/graphql';
import AnchorTreeNavigation from '@/components/AnchorTreeNavigation';
import Sidebar from '@/components/Sidebar';

const ExpandableLayoutSidebar = (props: PageExpandableEntryFragment) => {
  return (
    <Sidebar floating>
      <AnchorTreeNavigation {...props} />
    </Sidebar>
  );
};

export default ExpandableLayoutSidebar;
